import { getTermsAgreements, postTermsAgreements } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import { z } from 'zod';
import type {
  GetTermsAgreementsServiceResponse,
  PostTermsAgreementsServiceRequest,
  PostTermsAgreementsServiceResponse,
} from './terms-agreements.dto';
import {
  GetTermsAgreementsServiceResponseSchema,
  PostTermsAgreementsServiceRequestSchema,
  PostTermsAgreementsServiceResponseSchema,
} from './terms-agreements.dto';

export const getTermsAgreementsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(z.void()),
    async (): Promise<GetTermsAgreementsServiceResponse> => {
      const response = await getTermsAgreements();

      return {
        agreedTerms: response.data.termsTypes,
      };
    },
    validateServiceResponse(GetTermsAgreementsServiceResponseSchema),
  ),
);

export const postTermsAgreementsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(PostTermsAgreementsServiceRequestSchema),
    async (
      request: PostTermsAgreementsServiceRequest,
    ): Promise<PostTermsAgreementsServiceResponse> => {
      const response = await postTermsAgreements(request);

      return {
        agreedTerms: response.data.termsTypes,
      };
    },
    validateServiceResponse(PostTermsAgreementsServiceResponseSchema),
  ),
);
